document.addEventListener('DOMContentLoaded', function () {
  const triggers = document.querySelectorAll('.video-trigger');
  const popup = document.getElementById('video-popup');
  const popupVideo = document.getElementById('popup-video');
  const closePopup = document.querySelector('.close-popup');
  const closePopupIcon = document.querySelector('.video-icon-close');

  triggers.forEach(trigger => {
    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      const videoUrl = this.getAttribute('data-video-url');
      popup.querySelector('source').setAttribute('src', videoUrl);
      popupVideo.load();
      popup.classList.add('visible');
      popup.classList.remove('hidden');
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
    });
  });

  document.querySelectorAll('video').forEach((video) => video.pause());

  closePopup.addEventListener('click', function (e) {
    popup.classList.remove('visible');
    popup.classList.add('hidden');
    document.documentElement.style.overflow = 'initial';
    document.body.style.overflow = 'initial';
    popupVideo.pause();
  });

  closePopupIcon.addEventListener('click', function (e) {
    popup.classList.remove('visible');
    popup.classList.add('hidden');
    document.documentElement.style.overflow = 'initial';
    document.body.style.overflow = 'initial';
    popupVideo.pause();
  });

  /*popup.addEventListener('click', function (event) {
    debugger;
    if (event.target === popup) {
      debugger;
      popup.classList.remove('visible');
      popup.classList.add('hidden');
      document.documentElement.style.overflow = 'initial';
      document.body.style.overflow = 'initial';
      popupVideo.pause();
    }
  });*/
});